import React, { ReactNode } from "react";
import className from "classnames";

interface Props {
  collapseSection: boolean;
  onClick: () => void;
  headerTitle: ReactNode;
  abilityToClose: boolean;
  sectionTitleWithBtn?: boolean;
}

const SectionHeader: React.FC<Props> = (props: Props) => {
  const { collapseSection, onClick, headerTitle, abilityToClose, sectionTitleWithBtn } = props;

  let btnText = "Hide";
  if (collapseSection) {
    btnText = "Show";
  }

  const headerClass = className(
    "section-container-header",
    { "no-ability-to-close": !abilityToClose },
    { "reset-padding": sectionTitleWithBtn },
  );

  return (
    <div className={headerClass} onClick={onClick}>
      {headerTitle}
      {abilityToClose && (
        <span className="section-container-header-close-btn arrow arrow-left">
          <span className="arrow arrow-left" />
          {btnText}
        </span>
      )}
    </div>
  );
};

export default SectionHeader;
